const configuration = {
    prodPath: "https://services.avon.pl/api/leads/save",
    qafPath: "https://qaf-services.avon.pl/api/leads/save",
    local: "http://localhost:3002/leads/save",
};

export default configuration.prodPath;
